import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SeaLevel from './SeaLevel';

const DashboardElement = styled.div`
  z-index: 100;
  color: white;
  padding: 0;
  margin: 0;
  text-align: left;
  flex: 1;
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media only screen and (max-height: 479px),
         only screen and (max-width: 399px) {
    margin-top: 5px;
  }

  @media only screen and (max-width: 399px) {
    font-size: 0.6875rem;
  }
    `;

const Info = styled.span`
  cursor: default;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-right: 1em;

  sub {
    font-size: 0.7em;
    vertical-align: -0.3em;
  }

  @media only screen and (max-width: 980px) {
    ${(props) => props.secondary && css`
      order: 100;
      width: 100%;
    `}
  }
`;

/**
 * Dashboard element
 */
class Dashboard extends PureComponent {
  static propTypes = {
    stats: PropTypes.shape({
      co2: PropTypes.number.isRequired,
      temp: PropTypes.number.isRequired,
    }).isRequired,
  };

  /**
  * React Lifecycle method.
  * @return {jsx} jsx representation of the component.
  */
  render() {
    const { stats } = this.props;
    const { co2, temp } = stats;
    let co2str = ' –';

    if (co2 >= 0) {
      co2str = `${co2 >= 1000
        ? (co2 / 1000).toFixed(3).replace('.', ',')
        : parseInt(co2, 10)}PPM`;
    }

    return (
      <DashboardElement>
        <SeaLevel />
        <Info secondary>Scenario: Unchecked Emissions (RCP 8.5)</Info>
        <Info>
          CO
          <sub>2</sub>
          :
          {co2str}
        </Info>
        <Info>
          {`${temp >= 0 ? `+${temp.toFixed(1)}°C` : ''}`}
        </Info>
      </DashboardElement>
    );
  }
}

const calculateStats = (altitudes) => {
  if (altitudes.year > 2300) {
    return {
      co2: -1,
      temp: -1,
    };
  }
  const nextStepIndex = altitudes.all.findIndex(
      (it) => it.year >= altitudes.year,
  );

  const nextStep = altitudes.all[nextStepIndex];

  if (nextStep.year === altitudes.year) {
    return { co2: nextStep.co2ppm, temp: nextStep.temp };
  }

  const prevStep = altitudes.all[nextStepIndex > 0 ? nextStepIndex - 1 : 0];
  const interpolateBy = (altitudes.year - prevStep.year)
    / (nextStep.year - prevStep.year);

  return {
    co2: prevStep.co2ppm + (nextStep.co2ppm - prevStep.co2ppm) * interpolateBy,
    temp: prevStep.temp + (nextStep.temp - prevStep.temp) * interpolateBy,
  };
};

export default connect((state) => {
  const { altitudes } = state;

  return {
    stats: calculateStats(altitudes),
  };
})(Dashboard);
